import { IMagicEdenSellDto } from "../common/interfaces/magic-eden.interface";
import { get, post } from "./utilities/http";
import {
  ACTIVITIES,
  BUY_NOW,
  CANCEL,
  COLLECTION,
  NFT,
  SELL,
} from "./utilities/magic-eden.urls";
/**
 *
 * @param nftMint Mint of nft whose data is loaded from Magic eden
 * @returns Object with basic nft stats and array of listigs on Magic Eden (if nft is currently listed)
 */
export function getNftDataFromMagicEden(nftMint: string) {
  return get(`${NFT}/${nftMint}`);
}

/**
 *
 * @param collectionSymbol Symbol of collection of specific nft
 * @returns Object containing data about collection that is verified on Magic Eden
 */
export function getCollectionDataFromMagicEden(collectionSymbol: string) {
  return get(`${COLLECTION}/${collectionSymbol}`);
}
/**
 *
 * @param magicEdenRequest Magic Eden buy dto,containing requested data by Magic Eden Api
 * @returns Message of success
 */
export function buyNowMagicEden(
  escrowWantedTokenAccont: string,
  nftMint: string
) {
  return get(`${BUY_NOW}/${escrowWantedTokenAccont}/${nftMint}`);
}

/**
 *
 * @param magicEdenRequest Magic Eden sell dto,containing requested data by Magic Eden Api
 * @returns Message of success
 */
export function sellMagicEden(magicEdenRequest: IMagicEdenSellDto) {
  return post(SELL, magicEdenRequest);
}

// /**
//  *
//  * @param amount Amount that will be transfered back to treasury from custody wallet
//  * @param treasuryAddress Treasury address
//  * @returns
//  */
// export function cancelBuyTradeOnMagicEden(
//   amount: number,
//   treasuryAddress: string
// ) {
//   return get(
//     `${BUY_NOW}/${CANCEL}?amount=${amount}&treasuryAddress=${treasuryAddress}`
//   );
//}
/**
 *
 * @param vaultTokenAccountAddress Token account owned by vault
 * @param tokenMint Mint of nft that will be returned to vault
 * @returns
 */
export function cancelSellTradeMagicEden(tokenMint: string) {
  return get(`${SELL}/${CANCEL}/${tokenMint}`);
}
// /**
//  *
//  * @param escrowWantedTa Address of escrow wanted token account
//  * @param amount Total amount of tokens that will be distributed
//  * @returns
//  */
// export function transferMoneyToEscrowWantedTokenAccount(
//   escrowWantedTa: string,
//   amount: number
// ) {
//   return get(`${SELL}/${DISTRIBUTE}/${escrowWantedTa}/${amount}`);
// }
/**
//  *
//  * @param escrowWantedTokenAccount Address of escrow wanted token account
//  * @param nftMint Mint of nft that will be transfered
//  * @returns
//  */
// export function transferNftFromMeAuthorityToEscrowWantedTokenAccount(
//   escrowWantedTokenAccount: string,
//   nftMint: string
// ) {
//   return get(`${BUY_NOW}/${RETRY}/${nftMint}/${escrowWantedTokenAccount}`);
// }
/**
 *
 * @param nftMint Mint of nft whose activities will be loaded from Magic Eden
 * @returns
 */
export function getNftActivities(nftMint: string) {
  return get(`${NFT}/${ACTIVITIES}/${nftMint}`);
}
